import { render, staticRenderFns } from "./OrderPollingEvent.vue?vue&type=template&id=4ae0840c&"
import script from "./OrderPollingEvent.vue?vue&type=script&lang=ts&"
export * from "./OrderPollingEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports